import { useLocation } from "react-router-dom";

const useTailUrl = () => {
  const location = useLocation();
  const tailUrl = location.pathname.split("/").slice(-1);
  return tailUrl;
};

export default useTailUrl;
